import { Component, OnInit } from '@angular/core';
import { MatCard, MatCardContent } from '@angular/material/card';

@Component({
  selector: 'app-complete-order',
  templateUrl: './complete-order.component.html',
  styleUrls: ['./complete-order.component.scss'],
  imports: [MatCard, MatCardContent],
})
export class CompleteOrderComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
